import { render, staticRenderFns } from "./service-us-us.vue?vue&type=template&id=03275e2b&"
import script from "./service-us-us.vue?vue&type=script&lang=js&"
export * from "./service-us-us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports